<template>
  <div class="shell-page">
    <HeaderMain v-show="!loadingEvent" @messageFromHeader="searchEvents" />
    <SlideShow main="Reserva tu acceso Zocial" subtitle="Una vista de reserva mas limpia y directa para completar tu registro sin friccion." />
    <SearchCourse v-if="!main" :courses="search" />

    <section class="shell-section" style="padding-top: 24px; padding-bottom: 70px;">
      <PreloaderComponent v-show="validateProc() === false" />

      <div v-show="validateProc() === true" class="glass-surface static-info-card">
        <div class="section-heading" style="margin-bottom: 20px;">
          <span class="section-heading__eyebrow">Reservation form</span>
          <h2 class="section-heading__title">Zocial reservation experience</h2>
          <p class="section-heading__text">Completa tu reserva dentro de una superficie mas elegante, oscura y enfocada en conversión.</p>
        </div>

        <div id="cognito-form"></div>
      </div>
    </section>

    <FooterMain v-show="!loadingEvent" />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import PreloaderComponent from '@/components/PreloaderComponent.vue'
import SlideShow from '@/components/SlideShow.vue'
import SearchCourse from '@/components/SearchCourse.vue'

export default {
  name: 'ZocialView',

  components: {
    HeaderMain,
    FooterMain,
    PreloaderComponent,
    SlideShow,
    SearchCourse,
  },

  data() {
    return {
      search: [],
      searchField: '',
      main: true,
      loadingEvent: false,
    }
  },

  mounted() {
    const script = document.createElement('script')
    script.src = 'https://www.cognitoforms.com/f/seamless.js'
    script.async = true
    script.setAttribute('data-key', '5mwehIbeiUCGXSRJH0Anpw')
    script.setAttribute('data-form', '84')
    document.getElementById('cognito-form').appendChild(script)
  },

  methods: {
    searchEvents(results, term) {
      this.search = results
      this.searchField = term
      this.main = term === ''
    },

    validateProc() {
      return true
    },
  },
}
</script>

<style>
</style>
